export default __webpack_public_path__ + "static/media/share_icon.c519d180.svg";